import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Carousel, Button, Image, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { 
  FaCheckCircle, FaBuilding, FaVials, FaHandshake, 
  FaWhatsapp, FaGoogle, FaStar, FaMapMarkerAlt, 
  FaTruck, FaIndustry, FaAward, FaUsers, FaHeadset
} from 'react-icons/fa';
import './Home.css';
import portada from './portada.webp';

// --------------------------------------------------------
// DATOS ESTÁTICOS 
// --------------------------------------------------------
const mainPhone = "542215739000";

const services = [
  {
    src: '/portadaplumamixer.jpg',
    title: 'HORMIGÓN ELABORADO Y BOMBEO',
    description: 'Calidad certificada CIRSOC 200/2024 con servicios de bombeo para proyectos de cualquier escala. Dosificación precisa y control de calidad en tiempo real.',
    features: ['Certificación CIRSOC 200/2024', 'Bombeo hasta 100m', 'Control tecnológico', 'Entrega programada'],
    backup: { text: 'ALIADO ESTRATÉGICO', logo: '/logolomanegra.png' },
    link: '/services/hormigon'
  },
  {
    src: '/portadacoralon.JPG',
    title: 'MATERIALES DE CONSTRUCCIÓN',
    description: 'Amplia gama de materiales seleccionados para cada etapa constructiva. Stock permanente y asesoramiento técnico especializado.',
    features: ['+200 productos', 'Stock garantizado', 'Asesoramiento técnico', 'Logística eficiente'],
    link: '/services/materiales'
  },
  {
    src: '/portadamovofi.jpg',
    title: 'ESTUDIO Y MOVIMIENTO DE SUELOS',
    description: 'Análisis precisos y preparación de terreno para cimentaciones seguras. Equipos modernos y personal calificado.',
    features: ['Estudios geotécnicos', 'Maquinaria especializada', 'Compactación controlada', 'Informes técnicos'],
    link: '/services/suelos'
  },
  {
    src: '/portadapisosindustriales.png',
    title: 'PISOS INDUSTRIALES',
    description: 'Soluciones duraderas para superficies de alto tránsito. Tecnología Sika y ejecución certificada.',
    features: ['Tecnología Sika', 'Resistencia superior', 'Acabados perfectos', 'Garantía extendida'],
    backup: { text: 'TECNOLOGÍA SIKA', logo: '/LOGOSIKA.png' },
    link: '/services/pisos'
  }
];

const featuredProducts = [
  { 
    src: '/mathidrofugosika20l.jpg', 
    name: 'Hidrofugo Sika 20 lts', 
    category: 'Impermeabilizantes',
    price: 'Consultar',
    link: '/services/materiales' 
  },
  { 
    src: '/matlad12.jpg', 
    name: 'Ladrillo 12x12x18', 
    category: 'Cerámicos',
    price: 'Consultar',
    link: '/services/materiales' 
  },
  { 
    src: '/matbolsonarena.jpg', 
    name: 'Arena en Bolsón', 
    category: 'Áridos',
    price: 'Consultar',
    link: '/services/materiales' 
  },
  { 
    src: '/matcementoloma50kg.jpg', 
    name: 'Cemento Loma Negra 50kg', 
    category: 'Cementos',
    price: 'Consultar',
    link: '/services/materiales' 
  }
];

const suppliers = [
  { src: '/logolomanegra.png', alt: 'Loma Negra' },
  { src: '/LOGOSIKA.png', alt: 'Sika' },
  { src: '/logoacindarofi.png', alt: 'Red Acindar' },
  { src: '/logodafre.jpg', alt: 'Dafre' },
  { src: '/logo varsovia.jpg', alt: 'Grupo Varsovia' },
  { src: '/LOGOTECMA.PNG', alt: 'Tecma' },
  { src: '/logoeleprint.png', alt: 'Eleprint' },
  { src: '/logogoldir.png', alt: 'Goldir' },
  { src: '/dycasalogo.jpg', alt: 'Ieb Construcciones' },
  { src: '/logoaubasa.png', alt: 'Aubasa' },
  { src: '/logopfisterer.png', alt: 'Pfisterer' },
  { src: '/logoweber.png', alt: 'Weber' },
  { src: '/logofanelli.png', alt: 'Fanelli' },
  { src: '/posesalogo.jpg', alt: 'Pose sa' },
  { src: '/logoctibor.png', alt: 'Ctibor' }
];

const testimonios = [
  { 
    text: "Excelente experiencia. Muy organizado, con seguimiento GPS del trayecto del camión, y el conductor, súper amable y muy colaborativo para facilitar la descarga. Recomiendo!", 
    author: "Sebastian Leis", project: "Cliente Particular", rating: 5
  },
  { 
    text: "Excelente desde la atención del vendedor hasta la logística. Muy profesionales! Recomiendo. Compromiso y Puntualidad eso genera la confianza!", 
    author: "Adriana Rosende", project: "Cliente Particular", rating: 5
  },
  { 
    text: "Excelente atención y logística. Fueron puntuales y organizados. Salió perfecto el trabajo, volveremos a contratarlos seguramente.", 
    author: "Construcciones La Plata", project: "Empresa Constructora", rating: 5
  },
  { 
    text: "Empresa muy profesional. Excelente atención y cumplimiento de lo pautado. La recomiendo.", 
    author: "Magda Cibei", project: "Cliente Particular", rating: 5
  },
  { 
    text: "Los super recomiendo. Tan amables desde el inicio de compra hasta el fin de obra. Te asesoran en todo y te responden todas tus dudas sin problemas. Gracias Darom.", 
    author: "Carina Zeiss", project: "Cliente Particular", rating: 5
  },
  { 
    text: "Los mejores! Compré todo el hierro, ladrillos, materiales para mi casa, llené la platea y 3 losas de hormigón de ellos, todo 10 puntos! Se destaca la atención, los productos y el servicio de entrega!", 
    author: "Pablo Laurito", project: "Casa Particular", rating: 5
  },
  { 
    text: "Super puntuales y están siempre al contacto con vos! Ya homigonamos unas 6 veces y siempre llegaron siempre horario, un lujo!", 
    author: "Ricardo Ramos", project: "Cliente Recurrente", rating: 5
  },
  { 
    text: "Muy buena atención. Eficaces y rapidez. Y sobre todo puntualidad y calidad. Excelente logística para una buena atención a sus clientes. Gracias…", 
    author: "Sebastian Godoy", project: "Empresa Constructora", rating: 5
  },
  { 
    text: "Excelente servicio de atención, no demoran las entregas, y hay seguimiento de los pedidos. Respuesta inmediata siempre y asesoramiento sobre materiales. Muy conforme!", 
    author: "Leonardo Yanson", project: "Cliente Particular", rating: 5
  },
  { 
    text: "Excelente servicio, cumplieron con los tiempos y todo lo pactado. Quiero destacar la buena predisposición y atención de Guillermo y su impecable programación. Los recomiendo!", 
    author: "Laura Scandroglio", project: "Reforma Integral", rating: 5
  },
  { 
    text: "La atención y la comunicación con sus clientes es impecable. Destaco la predisposición permanente al servicio de la resolución de problemas. Muy recomendable.", 
    author: "Arq. De los Santos", project: "Proyecto Arquitectónico", rating: 5
  }
];

const stats = [
  { value: '45+', label: 'Años de Experiencia', icon: FaAward },
  { value: '3000+', label: 'Proyectos Completados', icon: FaBuilding },
  { value: '3M+', label: 'm² Construidos', icon: FaIndustry },
  { value: '60+', label: 'Profesionales', icon: FaUsers }
];

// --------------------------------------------------------
// COMPONENTES REUTILIZABLES
// --------------------------------------------------------

// Pastilla de Google Maps aislada y con estilos forzados
const GoogleRatingBadge = () => (
  <div className="d-flex justify-content-center w-100 mt-4">
    <a 
      href="#reviews" 
      className="d-inline-flex align-items-center text-decoration-none py-2 px-4 shadow-lg bg-white rounded-pill" 
      style={{ transition: 'transform 0.2s', width: 'auto', whiteSpace: 'nowrap' }}
    >
      <FaGoogle className="text-danger me-2" size={20} />
      <div className="d-flex align-items-center mx-2 border-end border-secondary border-opacity-25 pe-3">
        <span className="fw-bold fs-5 me-1" style={{ color: '#212529' }}>4.7</span>
        <FaStar className="text-warning" size={18} />
      </div>
      <span className="small ms-2 fw-bold" style={{ color: '#495057' }}>50+ Reseñas Verificadas</span>
    </a>
  </div>
);

const ServiceCard = ({ service }) => (
  <Card className="home-service-card shadow-lg h-100 border-0">
    <div className="service-image-container position-relative">
      <Card.Img variant="top" src={service.src} alt={service.title} loading="lazy" className="service-img" />
      {service.backup && (
        <div className="backup-badge bg-white p-2 rounded shadow-sm d-flex flex-column align-items-center">
          <small className="text-dark fw-bold mb-1" style={{fontSize: '0.65rem'}}>{service.backup.text}</small>
          <img src={service.backup.logo} alt="Logo proveedor" loading="lazy" style={{maxHeight: '25px'}} />
        </div>
      )}
    </div>
    <Card.Body className="d-flex flex-column position-relative p-4" style={{ zIndex: 10 }}>
      <Card.Title className="h5 fw-bold mb-3">{service.title}</Card.Title>
      <Card.Text className="flex-grow-1 text-muted small">{service.description}</Card.Text>
      
      <ul className="service-features list-unstyled small mb-4 border-top pt-3">
        {service.features?.map((feature, idx) => (
          <li key={idx} className="mb-2 d-flex align-items-center text-dark">
            <FaCheckCircle className="text-danger me-2" size={14} />
            {feature}
          </li>
        ))}
      </ul>
      
      <Button as={Link} to={service.link} variant="outline-danger" className="w-100 mt-auto fw-bold py-2 shadow-sm">
        VER DETALLES
      </Button>
    </Card.Body>
  </Card>
);

const ProductCard = ({ product }) => (
  <Card className="product-card text-center h-100 shadow-sm border-0">
    <div className="overflow-hidden">
      <Card.Img variant="top" src={product.src} alt={product.name} loading="lazy" className="product-img p-3" />
    </div>
    <Card.Body className="d-flex flex-column p-4">
      <Badge bg="danger" className="mb-3 align-self-center">{product.category}</Badge>
      <Card.Title className="h6 fw-bold mb-3">{product.name}</Card.Title>
      <div className="product-price mb-3">
        <strong className="text-dark">Precio: </strong>
        <strong className="text-danger">{product.price}</strong>
      </div>
      <Link to={product.link} className="mt-auto text-decoration-none">
        <Button variant="outline-dark" size="sm" className="w-100 fw-bold py-2">
          AGREGAR A COTIZACIÓN
        </Button>
      </Link>
    </Card.Body>
  </Card>
);

const StatsCard = ({ stat }) => {
  const IconComponent = stat.icon;
  return (
    <div className="text-center text-white p-3">
      <IconComponent size={48} className="mb-3 text-danger opacity-75" />
      <h3 className="display-6 fw-bold mb-2">{stat.value}</h3>
      <p className="mb-0 opacity-90 text-uppercase tracking-wider" style={{fontSize: '0.9rem'}}>{stat.label}</p>
    </div>
  );
};

// --------------------------------------------------------
// COMPONENTE PRINCIPAL (HOME)
// --------------------------------------------------------
function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container fluid className="px-0">
      <Helmet>
        <title>Darom SA - Líderes en Hormigón y Materiales para Construcción | Zona Sur</title>
        <meta name="description" content="Darom SA: 45 años liderando el mercado de hormigón elaborado, materiales de construcción y pisos industriales. Calidad certificada CIRSOC 200/2024, entrega inmediata en Zona Sur." />
        <meta name="keywords" content="hormigón elaborado, materiales construcción, pisos industriales, estudio suelos, construcción Buenos Aires, Darom SA, CADHE, CIRSOC 200/2024" />
        
        {/* BLOQUE SEO JSON-LD PRINCIPAL DE LA EMPRESA */}
        <script type="application/ld+json">
            {`{
                "@context": "https://schema.org",
                "@type": "LocalBusiness",
                "name": "Darom SA",
                "image": "https://daromsa.com.ar/portada.webp",
                "description": "Líderes en hormigón elaborado y distribución de materiales de construcción en la Zona Sur del Gran Buenos Aires.",
                "url": "https://daromsa.com.ar",
                "telephone": "+54-221-573-9000",
                "address": {
                    "@type": "PostalAddress",
                    "addressLocality": "Florencio Varela",
                    "addressRegion": "Buenos Aires",
                    "addressCountry": "AR"
                },
                "areaServed": ["Berazategui", "La Plata", "Florencio Varela", "Quilmes", "Avellaneda"],
                "priceRange": "$$"
            }`}
        </script>
      </Helmet>

      {/* Hero Section con CTA Simplificado */}
      <section className="hero-section">
        <div className="hero-background" style={{ backgroundImage: `url(${portada})` }}></div>
        <div className="hero-overlay">
          <Container>
            <Row className="align-items-center min-vh-80 py-5">
              <Col lg={7} className="text-center text-lg-start mb-5 mb-lg-0">
                <Badge bg="danger" className="mb-3 px-3 py-2 tracking-wider">
                  <FaAward className="me-2" />LÍDERES DESDE 1978
                </Badge>
                <h1 className="hero-title mb-3 text-white fw-bold">
                  CONSTRUIMOS LAS <span className="text-warning">BASES</span> DE TU PROYECTO
                </h1>
                <p className="hero-subtitle lead mb-4 text-white opacity-90">
                  Más de 45 años proporcionando soluciones integrales en hormigón, materiales y pisos industriales para obras de cualquier escala en Zona Sur.
                </p>
                
                {/* CTA Compacto */}
                <div className="d-flex justify-content-center justify-content-lg-start">
                  <div className="bg-black bg-opacity-50 p-4 rounded-4 border border-light border-opacity-25 backdrop-blur shadow-lg w-100" style={{maxWidth: '400px'}}>
                    
                    {/* Botón de WhatsApp en Rojo institucional */}
                    <Button 
                      variant="danger"
                      size="lg"
                      href={`https://wa.me/${mainPhone}?text=Hola%20Darom%20SA,%20me%20interesa%20solicitar%20un%20presupuesto`}
                      target="_blank"
                      className="px-4 py-3 fw-bold shadow-lg w-100 d-flex align-items-center justify-content-center mb-3 text-white"
                    >
                      <FaWhatsapp className="me-2" size={24} />
                      COTIZAR AHORA
                    </Button>
                    
                    <div className="text-center">
                      <div className="d-flex justify-content-center align-items-center gap-2 mb-1">
                        <FaHeadset className="text-danger" size={14} />
                        <span className="text-light fw-bold" style={{fontSize: '0.75rem', letterSpacing: '1px'}}>LÍNEA COMERCIAL ÚNICA</span>
                      </div>
                      <a href={`tel:+${mainPhone}`} className="text-decoration-none text-white fs-4 fw-bold contact-phone-hover">
                        +54 221 573-9000
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
              
              <Col lg={5} className="text-center">
                {/* Panel de Logos */}
                <div className="partner-logo-container p-4 rounded-4 bg-black bg-opacity-25 backdrop-blur border border-white border-opacity-10 d-inline-block">
                  <p className="text-white mb-3 small fw-bold tracking-wider">CALIDAD CERTIFICADA Y RESPALDO</p>
                  
                  <div className="d-flex justify-content-center align-items-center gap-4 my-3">
                    <img 
                      src="/logolomanegra.png" 
                      alt="Loma Negra" 
                      className="img-fluid"
                      style={{ maxHeight: '90px', objectFit: 'contain' }}
                      loading="lazy" 
                    />
                    <div className="vr text-white opacity-25" style={{ minHeight: '60px' }}></div>
                    <img 
                      src="/CADHE-Logo.png" 
                      alt="CADHE" 
                      className="img-fluid"
                      style={{ maxHeight: '95px', objectFit: 'contain' }}
                      loading="lazy" 
                    />
                  </div>
                  <p className="text-white mt-2 small mb-0 opacity-75">
                    Operamos bajo normativas CADHE y altos estándares CIRSOC 200/2024.
                  </p>
                </div>
                
                {/* Google Reviews Badge (Componente reutilizable arreglado) */}
                <GoogleRatingBadge />
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-4 bg-dark">
        <Container>
          <Row className="g-4 border-bottom border-secondary border-opacity-25 pb-4">
            {stats.map((stat, index) => (
              <Col key={index} xs={6} md={3}>
                <StatsCard stat={stat} />
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Compromiso Section */}
      <section className="py-5 bg-light">
        <Container>
          <Row className="align-items-center">
            <Col md={6} className="mb-4 mb-md-0">
              <div className="ratio ratio-16x9 rounded overflow-hidden shadow-lg border border-white border-4">
                <iframe 
                  src="https://www.youtube.com/embed/--7y8f63ZPk" 
                  title="Video institucional Darom SA"
                  allowFullScreen
                  loading="lazy"
                  className="video-embed"
                ></iframe>
              </div>
              <div className="text-center mt-3">
                <small className="text-muted fw-bold">Conocé nuestra planta y procesos de calidad</small>
              </div>
            </Col>
            
            <Col md={6}>
              <div className="text-center text-md-start mb-4 ps-md-4">
                <Badge bg="danger" className="mb-3 px-3 py-2">NUESTRO COMPROMISO</Badge>
                <h2 className="section-title-custom mb-4 display-6 fw-bold">
                  Calidad que Perdura por Generaciones
                </h2>
                
                <div className="commitment-grid">
                  <div className="commitment-item mb-4 d-flex align-items-start">
                    <div className="commitment-icon bg-danger p-3 rounded-circle shadow-sm me-3 flex-shrink-0">
                      <FaCheckCircle className="text-white" size={24} />
                    </div>
                    <div>
                      <h5 className="fw-bold mb-1">Calidad Certificada CIRSOC 200/2024</h5>
                      <p className="small text-muted mb-0">Materiales con certificación nacional e internacional.</p>
                    </div>
                  </div>
                  
                  <div className="commitment-item mb-4 d-flex align-items-start">
                    <div className="commitment-icon bg-danger p-3 rounded-circle shadow-sm me-3 flex-shrink-0">
                      <FaHandshake className="text-white" size={24} />
                    </div>
                    <div>
                      <h5 className="fw-bold mb-1">Asesoría Técnica Especializada</h5>
                      <p className="small text-muted mb-0">Ingenieros disponibles para optimizar tu proyecto.</p>
                    </div>
                  </div>
                  
                  <div className="commitment-item mb-4 d-flex align-items-start">
                    <div className="commitment-icon bg-danger p-3 rounded-circle shadow-sm me-3 flex-shrink-0">
                      <FaBuilding className="text-white" size={24} />
                    </div>
                    <div>
                      <h5 className="fw-bold mb-1">Experiencia Comprobada</h5>
                      <p className="small text-muted mb-0">+3000 proyectos ejecutados con éxito en la región.</p>
                    </div>
                  </div>
                  
                  <div className="commitment-item d-flex align-items-start">
                    <div className="commitment-icon bg-danger p-3 rounded-circle shadow-sm me-3 flex-shrink-0">
                      <FaVials className="text-white" size={24} />
                    </div>
                    <div>
                      <h5 className="fw-bold mb-1">Control de Calidad Riguroso</h5>
                      <p className="small text-muted mb-0">Pruebas de laboratorio bajo norma CIRSOC 200/2024 en cada fase de producción y entrega.</p>
                    </div>
                  </div>
                  
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Servicios Section */}
      <section id="servicios" className="py-5 bg-white">
        <Container>
          <Row className="text-center mb-5">
            <Col>
              <div className="text-center mb-3">
                <Badge bg="danger" className="px-3 py-2">NUESTROS SERVICIOS</Badge>
              </div>
              <h2 className="section-title-custom mb-3 display-5 fw-bold">Soluciones Integrales</h2>
              <p className="lead text-muted">Acompañamos tu obra desde la cimentación hasta los acabados finales.</p>
            </Col>
          </Row>
          <Row className="g-4">
            {services.map((service, index) => (
              <Col key={index} lg={3} md={6}>
                <ServiceCard service={service} />
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Proveedores Section */}
      <section className="py-5 bg-light border-top">
        <Container>
          <h2 className="section-title-custom text-center mb-5 display-6 fw-bold">
            ALIANZAS ESTRATÉGICAS DE <span className="text-danger">PRIMER NIVEL</span>
          </h2>
          <Row className="justify-content-center g-4">
            {suppliers.map((supplier, index) => (
              <Col key={index} xs={4} sm={3} md={2} className="text-center">
                <div className="bg-white p-3 rounded-3 shadow-sm border border-light h-100 d-flex align-items-center justify-content-center">
                  <img 
                    src={supplier.src} 
                    alt={supplier.alt} 
                    className="img-fluid opacity-75 hover-opacity-100 transition-all" 
                    loading="lazy"
                    style={{maxHeight: '60px', objectFit: 'contain'}}
                  />
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Testimonios Section */}
      <section id="reviews" className="py-5 bg-white border-top">
        <Container>
          <Row className="text-center mb-5">
            <Col>
              <div className="text-center mb-3">
                <Badge bg="danger" className="px-3 py-2">OPINIONES VERIFICADAS</Badge>
              </div>
              <h2 className="section-title-custom display-6 fw-bold">Lo que Dicen Nuestros Clientes</h2>
            </Col>
          </Row>
          
          <Row>
            <Col lg={8} className="mx-auto">
              <Carousel indicators={true} interval={6000} pause="hover" variant="dark" className="pb-5">
                {testimonios.map((testimonio, index) => (
                  <Carousel.Item key={index}>
                    <div className="testimonial-card text-center p-4 p-md-5">
                      <div className="rating mb-4">
                        {[...Array(testimonio.rating)].map((_, i) => (
                          <FaStar key={i} className="text-warning fs-4 mx-1" />
                        ))}
                      </div>
                      <blockquote className="testimonial-text fs-5 mb-4 fst-italic text-muted">
                        "{testimonio.text}"
                      </blockquote>
                      <div className="testimonial-author">
                        <strong className="fs-5 text-dark">{testimonio.author}</strong>
                        <div className="text-danger small fw-bold mt-1">{testimonio.project}</div>
                      </div>
                    </div>
                  </Carousel.Item>
                ))}
              </Carousel>
              
              <div className="text-center mt-2">
                <Button 
                  variant="outline-dark" 
                  size="lg"
                  href="https://g.page/r/CYU8aD9k5psMEAE/review" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fw-bold px-4 rounded-pill"
                >
                  <FaGoogle className="me-2 text-danger" /> Dejar Mi Reseña
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Productos Destacados */}
      <section className="py-5 bg-light border-top">
        <Container>
          <Row className="text-center mb-5">
            <Col>
              <div className="text-center mb-3">
                <Badge bg="danger" className="px-3 py-2">CATÁLOGO</Badge>
              </div>
              <h2 className="section-title-custom display-6 fw-bold">Materiales de Primera Calidad</h2>
            </Col>
          </Row>
          
          <Row className="g-4 mb-5">
            {featuredProducts.map((product, index) => (
              <Col key={index} lg={3} md={6}>
                <ProductCard product={product} />
              </Col>
            ))}
          </Row>
          
          <Row>
            <Col className="text-center">
              <Link to="/services/materiales">
                <Button variant="danger" size="lg" className="fw-bold px-5 py-3 shadow-sm">
                  VER CATÁLOGO COMPLETO
                </Button>
              </Link>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Zona de Cobertura */}
      <section className="py-5 bg-dark text-white border-top border-5 border-danger">
        <Container>
          <Row className="align-items-center g-5">
            <Col lg={6}>
              <div className="text-center text-lg-start mb-4">
                <Badge bg="danger" className="mb-3 px-3 py-2 text-uppercase tracking-wider">Logística Propia</Badge>
              </div>
              
              <h2 className="section-title-custom mb-4 text-white text-center text-lg-start display-5 fw-bold">
                Entregas en Toda Zona Sur
              </h2>
              
              <p className="mb-4 text-white fs-5 opacity-90 text-center text-lg-start">
                Desde nuestro Parque Industrial en Florencio Varela, cubrimos 
                eficientemente toda Zona Sur del GBA con flota equipada y monitoreo GPS.
              </p>
              
              <div className="coverage-list bg-white bg-opacity-10 p-4 rounded-4 border border-white border-opacity-25">
                <div className="coverage-item d-flex align-items-center mb-4">
                  <div className="bg-danger p-3 rounded-circle me-3">
                    <FaMapMarkerAlt className="text-white" size={24} />
                  </div>
                  <div>
                    <strong className="text-white fs-5">Área de Cobertura</strong>
                    <div className="text-light small mt-1">
                      Berazategui, La Plata, Florencio Varela, Quilmes, Avellaneda, Puerto Madero.
                    </div>
                  </div>
                </div>
                
                <div className="coverage-item d-flex align-items-center mb-4">
                  <div className="bg-warning p-3 rounded-circle me-3">
                    <FaTruck className="text-dark" size={24} />
                  </div>
                  <div>
                    <strong className="text-white fs-5">Logística Optimizada</strong>
                    <div className="text-light small mt-1">
                      Flota propia · Entregas programadas · Seguimiento en tiempo real.
                    </div>
                  </div>
                </div>
                
                <div className="coverage-item d-flex align-items-center">
                  <div className="bg-success p-3 rounded-circle me-3">
                    <FaIndustry className="text-white" size={24} />
                  </div>
                  <div>
                    <strong className="text-white fs-5">Planta Central</strong>
                    <div className="text-light small mt-1">
                      Parque Industrial Tecnológico, Florencio Varela, Buenos Aires.
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            
            <Col lg={6}>
              <div className="coverage-map-container position-relative rounded-4 overflow-hidden shadow-lg border border-white border-opacity-25 p-2 bg-white">
                <Image 
                  src="/mapaoficial.png" 
                  alt="Zona de cobertura Darom SA" 
                  fluid 
                  className="coverage-map-sm rounded-3 w-100"
                  loading="lazy"
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* CTA Final Integrado y Simplificado */}
      <section className="cta-section py-5 bg-danger text-white">
        <Container>
          <Row className="align-items-center justify-content-center text-center text-lg-start g-4">
            <Col lg={7}>
              <h2 className="display-5 fw-bold mb-3">¿Necesitás asesoramiento urgente?</h2>
              <p className="fs-5 opacity-90 mb-0">
                Contactate ahora mismo con nuestra área comercial. Tenemos un equipo preparado para armar la logística de tu obra hoy mismo.
              </p>
            </Col>
            <Col lg={5}>
              <div className="bg-white p-4 rounded-4 shadow-lg text-center">
                <FaHeadset className="text-danger mb-3" size={40}/>
                <h4 className="fw-bold text-dark mb-4">Atención Comercial Única</h4>
                
                <Button 
                  variant="danger" 
                  size="lg"
                  className="w-100 py-3 fw-bold shadow-sm d-flex justify-content-center align-items-center mb-4"
                  href={`https://wa.me/${mainPhone}?text=Hola,%20me%20interesa%20solicitar%20un%20presupuesto`}
                  target="_blank"
                >
                  <FaWhatsapp className="me-2" size={24} />
                  COTIZAR POR WHATSAPP
                </Button>
                
                <hr className="text-muted opacity-25" />
                
                <p className="text-muted small fw-bold mb-1 mt-3">O llamanos directamente:</p>
                <a href={`tel:+${mainPhone}`} className="text-dark text-decoration-none fs-2 fw-bold d-block contact-phone-hover">
                  +54 221 573-9000
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

    </Container>
  );
}

export default Home;